/**
 * Created by Mikhail Menshenin on 13.12.2024
 */

const Persist = function () {
    this.persistNodes = {};
};

Persist.prototype.sendNode = function (node, name) {
    const key = name || node.__instanceId;
    this.persistNodes[key] = node;
    const movingNode = cleverapps.Scenes.GetMovingNode(node);
    node.replaceParentSamePlace(movingNode, { keepScale: true });
};

Persist.prototype.acceptNode = function (name, recipient) {
    const key = name || Object.keys(this.persistNodes)[0];
    const node = this.persistNodes[key];
    if (!node) {
        return;
    }

    delete this.persistNodes[key];
    if (recipient) {
        node.replaceParentSamePlace(recipient, { keepScale: true });
    }
    return node;
};
